export const AccountingActionEnum = Object.freeze({
  // Barang & Jasa
  INVENTORY: "INVENTORY",
  SALES_REVENUE: "SALES_REVENUE",
  SALES_RETURN: "SALES_RETURN",
  SALES_DISCOUNT: "SALES_DISCOUNT",
  GOODS_IN_TRANSIT: "GOODS_IN_TRANSIT",
  COST_OF_GOODS_SOLD: "COST_OF_GOODS_SOLD",
  PURCHASE_RETURN: "PURCHASE_RETURN",
  EXPENSE: "EXPENSE",
  UNBILLED_PAYABLES: "UNBILLED_PAYABLES",

  // Perusahaan
  OPENING_BALANCE_EQUITY: "OPENING_BALANCE_EQUITY",
  RETAINED_EARNINGS: "RETAINED_EARNINGS",
  INCOME_TAX_EXPENSE: "INCOME_TAX_EXPENSE",

  // Penjualan/Pembelian
  PPH21_PAYABLE: "PPH21_PAYABLE",
  PENSION_PAYABLE: "PENSION_PAYABLE",
  HEALTH_INSURANCE_PAYABLE: "HEALTH_INSURANCE_PAYABLE",
  EMPLOYEE_LOAN_RECEIVABLE: "EMPLOYEE_LOAN_RECEIVABLE",
  LOAN_INTEREST_RECEIVABLE: "LOAN_INTEREST_RECEIVABLE",
  DEFERRED_INTEREST_INCOME: "DEFERRED_INTEREST_INCOME",
  LOAN_INTEREST_INCOME: "LOAN_INTEREST_INCOME",
  LOAN_PENALTY_INCOME: "LOAN_PENALTY_INCOME",
  PAYMENT_DISCOUNT: "PAYMENT_DISCOUNT",
  TAX_ROUNDING_DIFFERENCE: "TAX_ROUNDING_DIFFERENCE",

  // Persediaan
  INVENTORY_ADJUSTMENT: "INVENTORY_ADJUSTMENT",
  STOCK_OPNAME_VARIANCE: "STOCK_OPNAME_VARIANCE",
  WORK_IN_PROGRESS: "WORK_IN_PROGRESS",
  JOB_COST_VARIANCE: "JOB_COST_VARIANCE",

  // Pelanggan
  ACCOUNTS_RECEIVABLE: "ACCOUNTS_RECEIVABLE",
  SALES_DOWN_PAYMENT: "SALES_DOWN_PAYMENT",
  ITEM_DISCOUNT: "ITEM_DISCOUNT",

  // Pemasok
  ACCOUNTS_PAYABLE: "ACCOUNTS_PAYABLE",
  PURCHASE_DOWN_PAYMENT: "PURCHASE_DOWN_PAYMENT",
});

export const AccountingActionCategory = Object.freeze({
  GOODS_AND_SERVICES: "GOODS_AND_SERVICES",
  COMPANY: "COMPANY",
  SALES_PURCHASE: "SALES_PURCHASE",
  INVENTORY: "INVENTORY",
  CUSTOMER: "CUSTOMER",
  SUPPLIER: "SUPPLIER",
});
